module.exports = __webpack_public_path__ + "static/media/aws_icon.9cd260ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aws_icon.svg
// module id = 2254
// module chunks = 0